import React, { useState, useEffect } from "react";

export function Tabs({ defaultValue, value, onValueChange, className, ...props }) {
  const [activeTab, setActiveTab] = useState(value || defaultValue);

  useEffect(() => {
    if (value !== undefined) {
      setActiveTab(value);
    }
  }, [value]);

  const handleValueChange = (newValue) => {
    setActiveTab(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <div className={className} {...props} data-active-tab={activeTab}>
      {React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
          if (child.type === TabsList) {
            return React.cloneElement(child, {
              children: React.Children.map(child.props.children, (listChild) => {
                if (React.isValidElement(listChild) && listChild.type === TabsTrigger) {
                  return React.cloneElement(listChild, {
                    activeTab,
                    onValueChange: handleValueChange,
                  });
                }
                return listChild;
              }),
            });
          } else if (child.type === TabsContent) {
            return React.cloneElement(child, {
              activeTab,
            });
          }
          return React.cloneElement(child, {
            activeTab,
            onValueChange: handleValueChange,
          });
        }
        return child;
      })}
    </div>
  );
}

export function TabsList({ className, children, ...props }) {
  return (
    <div
      className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 text-gray-500 ${className || ""}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function TabsTrigger({ value, activeTab, onValueChange, className, children, ...props }) {
  const isActive = activeTab === value;
  
  const handleClick = () => {
    if (typeof onValueChange === 'function') {
      onValueChange(value);
    }
  };
  
  return (
    <button
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
        isActive
          ? "bg-white text-indigo-700 shadow-sm"
          : "text-gray-600 hover:text-gray-900"
      } ${className || ""}`}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
}

export function TabsContent({ value, activeTab, className, children, ...props }) {
  if (activeTab !== value) {
    return null;
  }
  
  return (
    <div
      className={`mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${className || ""}`}
      {...props}
    >
      {children}
    </div>
  );
}
